module.exports = __webpack_public_path__ + "img/Flag_of_Hong_Kong.f16fe197.svg";